import React from 'react';

function ResultadoProposta({ result, formData, onDownloadPDF, onVisualizarPDF, onEditar }) {
  if (!result) return null;

  const contexto = result.contexto_pdf || {};
  const numModulos = contexto.num_modulos || '-';
  const valorTotal = contexto.proposta_valor || '-';
  const parcela36 = contexto.parcela_36 || '-';
  const parcela48 = contexto.parcela_48 || '-';
  const parcela60 = contexto.parcela_60 || '-';
  const geracaoNorte = contexto.geracao_norte || '-';
  const geracaoLesteOeste = contexto.geracao_leste_oeste || '-';
  const geracaoSul = contexto.geracao_sul || '-';

  // Estilos customizados com identidade visual
  const tableStyle = {
    fontSize: '0.96em',
    borderRadius: '14px',
    overflow: 'hidden',
    boxShadow: '0px 0px 8px rgba(255, 189, 0, 0.75)',
    border: '1.5px solid #ffbd00', // borda amarela
    borderColor: '#ffbd00', // força cor da borda
    background: '#fff',
  };
  const thStyle = {
    background: '#ffbd00',
    color: '#1a1a1a',
    fontWeight: 700,
    fontSize: '1em',
    borderBottom: '2px solid #ffbd00',
    textAlign: 'center',
  };
  const tdStyle = {
    verticalAlign: 'middle',
    textAlign: 'center',
    padding: '6px 6px',
    border: '1px solid rgba(255, 187, 0, 0.40)', // borda amarela nas células
    background: '#fff',
    fontSize: '0.96em',
    wordBreak: 'keep-all',
    color: '#1a1a1a',
  };

  return (
    <div
      className='pt-3 text-center'
      style={{
        background: '#1a1a1a',
        borderRadius: 18,
        boxShadow: '0 4px 24px rgba(0,0,0,0.10)',
        paddingBottom: '0px',
      }}
    >
      <div className='mb-3'>
        <table className='table table-sm mb-0' style={tableStyle}>
          <thead>
            <tr>
              <th style={{ ...thStyle, textAlign: 'center' }} colSpan={2}>
                Kit Fotovoltaico
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={tdStyle}>
                <b>Inversor</b>
              </td>
              <td style={tdStyle}>
                {contexto.inversor || '-'}
                <br />
                {contexto.modelo_inversor || '-'}
              </td>
            </tr>
            <tr>
              <td style={tdStyle}>
                <b>Módulos</b>
              </td>
              <td style={tdStyle}>
                {contexto.painel_solar || '-'}
                <br />
                {numModulos} x {contexto.potencia_modulo} Wp
                <br />
                {contexto.potencia_sistema ? `${contexto.potencia_sistema} kWp` : '-'}
              </td>
            </tr>
            <tr>
              <td style={tdStyle}>
                <b>Padrão necessário</b>
              </td>
              <td style={tdStyle}>{contexto.padrao_necessario || '-'}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className='mb-3'>
        <table className='table table-sm mb-0' style={tableStyle}>
          <thead>
            <tr>
              <th style={{ ...thStyle, textAlign: 'center' }} colSpan={2}>
                Geração
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={tdStyle}>
                <b>Norte</b>
              </td>
              <td style={tdStyle}>{geracaoNorte} kWh/mês</td>
            </tr>
            <tr>
              <td style={tdStyle}>
                <b>Leste/Oeste</b>
              </td>
              <td style={tdStyle}>{geracaoLesteOeste} kWh/mês</td>
            </tr>
            <tr>
              <td style={tdStyle}>
                <b>Sul</b>
              </td>
              <td style={tdStyle}>{geracaoSul} kWh/mês</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className='mb-3'>
        <table className='table table-sm mb-0' style={tableStyle}>
          <thead>
            <tr>
              <th style={{ ...thStyle, textAlign: 'center' }} colSpan={2}>
                Parcelamento
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={tdStyle}>
                <b>À vista</b>
              </td>
              <td style={tdStyle}>{valorTotal}</td>
            </tr>
            <tr>
              <td style={tdStyle}>
                <b>Em 36x de</b>
              </td>
              <td style={tdStyle}>{parcela36}</td>
            </tr>
            <tr>
              <td style={tdStyle}>
                <b>Em 48x de</b>
              </td>
              <td style={tdStyle}>{parcela48}</td>
            </tr>
            <tr>
              <td style={tdStyle}>
                <b>Em 60x de</b>
              </td>
              <td style={tdStyle}>{parcela60}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className='d-flex mt-3 justify-content-center'>
        <button
          className='btn w-100'
          style={{
            borderRadius: 8,
            fontWeight: 600,
            background: '#ffbd00',
            boxShadow: '0px 0px 6px rgba(255, 189, 0, 0.5)',
            color: '#000',
            border: 'none',
            fontSize: '1.08em',
            width: '100%',
            maxWidth: 370, // igual ao maxWidth do card principal
          }}
          onClick={onDownloadPDF}
        >
          Baixar PDF
        </button>
      </div>
      <div className='mt-2 d-flex justify-content-center'>
        <button
          className='btn'
          style={{
            borderRadius: 8,
            fontWeight: 600,
            background: '#505050',
            color: '#fff',
            border: 'none',
            fontSize: '0.98em',
            width: 120,
            marginTop: 4,
            padding: '6px 0',
          }}
          onClick={onEditar}
        >
          Editar Dados
        </button>
      </div>
    </div>
  );
}

export default ResultadoProposta;
